<template>
  <div class="wrapper">
  </div>
</template>
<script>
import router from '../router/index.js'
import ably from '../core/ably'
export default {
  data () {
    return {}
  },
  methods: {
    logOut () {
      ably.close()
      sessionStorage.clear()
      router.push({ path: 'Login' })
    }
  },
  mounted: function () {
    this.logOut()
  }
}

</script>

<style lang="scss" scoped>
$danger: hsl(348, 100%, 61%);
.error-text
{
  color:$danger;
  margin-bottom:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Logout.vue